export const logInfo = (message: string) => {
    console.log(
        JSON.stringify({
            level: 'info',
            status: 'info',
            message: `${message}`,
            timestamp: new Date().toISOString(),
            applicationLog: true,
        }),
    );
};

export const logError = (message: string, error?: Error) => {
    const payload: Record<string, unknown> = {
        level: 'error',
        status: 'error',
        message,
        timestamp: new Date().toISOString(),
        applicationLog: true,
    };

    if (error) {
        payload.errorMessage = error.message;
    }

    console.error(JSON.stringify(payload));
};
